   import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import virkrant from "../../../assets/vikrant_logo.png"
import {motion} from "framer-motion"
export default function Gallery() {
  const logo = [virkrant,'https://dbqa318yoj3nn.cloudfront.net/oc1.png','https://dbqa318yoj3nn.cloudfront.net/oc2.png','https://dbqa318yoj3nn.cloudfront.net/oc3.png','https://dbqa318yoj3nn.cloudfront.net/oc4.png','https://dbqa318yoj3nn.cloudfront.net/oc5.png'];
  const logo2 =['https://dbqa318yoj3nn.cloudfront.net/oc6.png','https://dbqa318yoj3nn.cloudfront.net/oc7.png','https://dbqa318yoj3nn.cloudfront.net/oc8.png','https://dbqa318yoj3nn.cloudfront.net/oc9.png','https://dbqa318yoj3nn.cloudfront.net/oc10.png'];

  const settings = {
    infinite: true,
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  };

  return (
    <div 
    className="w-full flex flex-col  items-center  min-h-[607px]" 
    style={{
      backgroundImage: `
        radial-gradient(at top left, #8db5f5 5%, transparent 30%),
        radial-gradient(at bottom right, #8db5f5 5%, transparent 30%),
        radial-gradient(circle, rgba(255,255,255,0.2) 20%, rgba(255,255,255,0) 35%)
      `,
      backgroundBlendMode: 'soft-light'
    }}
  >
      
      <motion.div whileHover={{scaleY:1.2,scaleX:1.1}} className="flex  " style={{ fontFamily: "Montserrat" }}>
          <div className="text-4xl font-extrabold text-gray-900 "   style={{ fontFamily: "Montserrat" }}>OUR</div>
          <div className="text-4xl ml-2 text-blue-600 font-extrabold"  style={{ fontFamily: "Montserrat" }}>CLIENTS</div>
        </motion.div>
        <div 
          className="flex justify-center text-center  font-semibold  mt-3 text-lg" 
          style={{ fontFamily: "Montserrat" }}
        >
          <h1  style={{ fontFamily: "Montserrat" }}>Trusted by the institutions that shape tomorrow's leaders.</h1>
        </div>

        <div className="flex flex-col lg:flex-row w-full  h-full">

          

          <div className="w-full lg:w-[50%] h-full pt-2 flex flex-col"> 
            

            {/* Map image for xs-sm-md with dots */}
            <div className="block lg:hidden w-full flex justify-center mt-4 relative">
              <img src='https://dbqa318yoj3nn.cloudfront.net/Map%201.png' alt="map" className="h-[330px] md:h-[420px] xs:ml-12  w-auto object-contain" />
              
              {/* Glowing Dots for Mobile */}
              <div className="absolute inset-0 flex justify-center items-center">
                <div className="relative w-full h-full" style={{ maxWidth: '600px', maxHeight: '400px' }}>
                        <div 
                      className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
                      style={{
                        top: '40%',
                        left: '43%',
                        boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
                      }}
                    ></div>

<div 
              className="absolute xs:w-1 xs:h-1 rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
            <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '35%',
                left: '40%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
             <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '50%',
                left: '35%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                 <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '49%',
                left: '45%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                  <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '13%',
                left: '38%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

            <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '28%',
                left: '40%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                    <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '32%',
                left: '40%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

<div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '30%',
                left: '36%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

<div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '38%',
                left: '35%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                                  
                  </div>
              </div>
            </div>

            {/* Carousels */}
            <div className="flex flex-col md:flex-row xs:pl-14 justify-center items-center h-full w-full mt-4">
              {/* First Carousel */}
              <div className="w-full md:w-[50%] h-auto p-4 bg-transparent flex items-center justify-center">
                <div className="w-full max-w-[240px] h-fit">
                  <Slider {...settings}>
                    {logo.map((image, index) => (
                      <div key={`logo-${index}`} className="flex justify-center items-center py-2">
                        <motion.div whileHover={{scale:1.1}} className="h-[130px] w-[180px] bg-white  rounded-xl shadow-[4px_4px_6px_-1px_rgba(0,0,0,0.2),2px_2px_4px_-1px_rgba(0,0,0,0.2)] flex items-center justify-center">
                          <img
                            src={image}
                            alt={`Client ${index + 1}`}
                            className="max-h-[120px] max-w-[145px] object-contain transition-transform hover:scale-105 duration-300"
                          />
                        </motion.div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>

              {/* Second Carousel */}
              <div className="w-full md:w-[50%] h-auto p-4 bg-transparent flex items-center justify-center">
                <div className="w-full max-w-[240px] h-fit">
                  <Slider {...settings}>
                    {logo2.map((image, index) => (
                      <div key={`logo2-${index}`} className="flex justify-center items-center py-2">
                        <motion.div whileHover={{scale:1.1}} className="h-[130px] w-[180px] bg-white  rounded-xl shadow-[4px_4px_6px_-1px_rgba(0,0,0,0.2),2px_2px_4px_-1px_rgba(0,0,0,0.2)] flex items-center justify-center">
                          <img
                            src={image}
                            alt={`Client ${index + 1}`}
                            className="max-h-[120px] max-w-[145px] object-contain transition-transform hover:scale-105 duration-300"
                          />
                        </motion.div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>



          <div className="hidden lg:flex w-full lg:w-[50%] relative justify-center items-center">
        <img src='https://dbqa318yoj3nn.cloudfront.net/Map%201.png' alt="map" className="h-[520px] xs:ml-[2%]  flex w-[600px] object-contain" />

        {/* Glowing Dots for Desktop */}
        <div className="absolute inset-0 flex justify-center items-center">
          <div className="relative" style={{ width: '600px', height: '550px' }}>
            <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '45%',
                left: '37%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
            <div 
              className="absolute xs:w-1 xs:h-1 rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
            <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '35%',
                left: '40%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
             <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '50%',
                left: '35%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                 <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '49%',
                left: '45%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                  <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '13%',
                left: '35%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

            <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '29%',
                left: '34%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>
                    <div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '32%',
                left: '36%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

<div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                top: '32%',
                left: '33%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

<div 
              className="absolute xs:w-1 xs:h-1  rounded-full bg-blue-600 animate-pulse"
              style={{
                bottom: '38%',
                left: '35%',
                boxShadow: '0 0 0 5px rgba(96, 165, 250, 0.5), 0 0 12px 8px rgba(96, 165, 250, 0.3)'
              }}
            ></div>

          </div>
        </div>
      </div>

        </div>





    
     


    </div>
  );
}